import { __awaiter } from "tslib";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { ButtonVariant, InteractiveImage, LinkTarget } from '@as/cotopaxi';
import { useAemConfig } from '@as-react/common-components';
import { fixProductColoursFallback, mergeProductPricesToProductLister } from '@as-react/common-utils';
import { Box, TextAlpha } from '@yonderland/andes-react';
import { useState } from 'react';
import ProductDetailAPI from '../../api/ProductDetailAPI';
import ProductsAPI from '../../api/ProductsAPI';
import { MiniPDPContainer } from '../../containers/MiniPDPContainer';
import { getPictureSrcset } from '../../util/ImageUtil';
const hasProductFallback = (marker) => !!marker.productFallback && !!marker.productFallback.id && !!marker.productFallback.color;
const ProductInspiration = ({ title, subTitle, image, buttons, deliveryPromiseExplanations, cdnSettings, }) => {
    const { defaultRequestParams, servicesEndpoint, imageCdnPrefix } = useAemConfig();
    const [miniPDPProduct, setMiniPDPProduct] = useState(null);
    const [activeMarker, setActiveMarker] = useState(null);
    const srcset = getPictureSrcset({ imagePath: image.imagePath, renditions: image.renditions, lastModified: image.lastModified }, imageCdnPrefix, cdnSettings === null || cdnSettings === void 0 ? void 0 : cdnSettings.imageQuality, cdnSettings === null || cdnSettings === void 0 ? void 0 : cdnSettings.requestPassThrough);
    const getRenditionIdFromClickMapKey = (clickMapKey) => clickMapKey.substring(clickMapKey.lastIndexOf('/') + 1);
    const onClickMarker = (marker) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const fallbackProducts = hasProductFallback(marker)
                ? [
                    {
                        productCode: marker.productFallback.id,
                        productColor: marker.productFallback.color,
                    },
                ]
                : undefined;
            const result = yield ProductsAPI.getSingleProductData(servicesEndpoint, defaultRequestParams.mainWebshop, defaultRequestParams.anaLang, defaultRequestParams.language, defaultRequestParams.shopId, marker.product.id, marker.product.color, fallbackProducts, true);
            if (result) {
                const product = hasProductFallback(marker) ? fixProductColoursFallback(result) : result;
                const productPrice = yield ProductDetailAPI.getProductDetailPriceByProductId(servicesEndpoint, defaultRequestParams.mainWebshop, defaultRequestParams.shopId, product.productId);
                const mergedProduct = mergeProductPricesToProductLister(product, productPrice);
                setActiveMarker(marker.markerId);
                setMiniPDPProduct(mergedProduct);
            }
        }
        catch (_a) { }
    });
    const maps = image.clickMaps
        ? Object.keys(image.clickMaps).map(clickMapKey => {
            var _a, _b;
            return ({
                renditionId: getRenditionIdFromClickMapKey(clickMapKey),
                points: (_b = (_a = image.clickMaps) === null || _a === void 0 ? void 0 : _a[clickMapKey]) === null || _b === void 0 ? void 0 : _b.map(marker => ({
                    id: marker.markerId.toString(),
                    x: marker.point.x,
                    y: marker.point.y,
                    onClick: () => onClickMarker(marker),
                    isActive: marker.markerId === activeMarker,
                })),
            });
        })
        : undefined;
    const mappedButtons = buttons
        ? buttons.map(button => {
            const variantKey = Object.keys(ButtonVariant).find(key => {
                return ButtonVariant[key].toLowerCase() === button.variant.toLowerCase();
            });
            return {
                text: button.label,
                title: button.alt,
                variant: ButtonVariant[variantKey],
                href: button.href,
                target: button.target ? LinkTarget.BLANK : undefined,
                iconLeft: button.iconLeft
                    ? {
                        name: button.iconLeft,
                    }
                    : undefined,
                iconRight: button.iconRight
                    ? {
                        name: button.iconRight,
                    }
                    : undefined,
            };
        })
        : undefined;
    const handleMiniPDPClose = () => {
        setActiveMarker(null);
        setMiniPDPProduct(null);
    };
    return (_jsxs(_Fragment, { children: [!!title && (_jsx(TextAlpha, { as: "h2", variant: "subheadingXL", alignment: "center", children: title })), !!subTitle && (_jsx(TextAlpha, { variant: "bodyS", alignment: "center", children: subTitle })), _jsx(Box, { paddingBlockStart: title && subTitle ? '6' : undefined, children: _jsx(InteractiveImage, { image: {
                        src: `${imageCdnPrefix}${image.imagePath}`,
                        srcset: srcset,
                        lazy: image.lazy,
                    }, maps: maps, buttons: mappedButtons }) }), _jsx(MiniPDPContainer, { displayPackShotImagesFirst: true, productCode: miniPDPProduct === null || miniPDPProduct === void 0 ? void 0 : miniPDPProduct.productCode, colorId: miniPDPProduct === null || miniPDPProduct === void 0 ? void 0 : miniPDPProduct.colourId, deliveryPromiseExplanations: deliveryPromiseExplanations, onClose: handleMiniPDPClose })] }));
};
export default ProductInspiration;
